import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { Skeleton, Box } from "@mui/material";
import { themeColors } from "../../utils/theme";

interface ProtectedRouteProps {
  redirectPath?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  redirectPath = "/login",
}) => {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return (
      <Box
        sx={{
          p: 3,
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Skeleton
          variant="rectangular"
          width={300}
          height={200}
          sx={{
            borderRadius: 2,
            bgcolor: `${themeColors.accent}40`,
            '&::after': {
              background: `linear-gradient(90deg, transparent, ${themeColors.primary}20, transparent)`,
            },
          }}
        />
      </Box>
    );
  }

  if (!currentUser) {
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
